const getDestinationRoute = (destinationName) =>
  `destinations/${destinationName}`;

export default getDestinationRoute;
